
/* injects from baggage-loader */

'use strict';

export default class PageNotFoundController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/page-not-found/page-not-found.controller.js